import React from "react";
import { AllTodo } from "../component/AllTodo";

export const Dashboard = () => {
    return (
        <>
        <AllTodo/>
        </>
    )
}